var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-page"},[_c('h1',[_vm._v(_vm._s(_vm.$t('not_found.page.text.title')))]),_c('router-link',{staticClass:"btn btn-primary",attrs:{"to":"/"}},[_vm._v(_vm._s(_vm.$t('not_found.page.button.back')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }